import ShipmentOrganization from './shipment-organization-container';

export default ShipmentOrganization;